import {
  AsyncPipe,
  NgComponentOutlet,
  NgTemplateOutlet,
} from '@angular/common';
import { Component, InjectionToken, TemplateRef, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { isString } from 'lodash';
import type { Observable } from 'rxjs';
import type {
  OnyxTooltipContext,
  OnyxTooltipTemplateContext,
} from '../../../components/tooltip/interfaces';

export interface OnyxTooltipConfig {
  color: OnyxTooltipColor;
  context: OnyxTooltipContext;
  templateContext: OnyxTooltipTemplateContext;
  showArrow: boolean;
  textAlign: 'left' | 'center' | 'right';
  arrowPosition$: Observable<{ x: number; y: number }>;
  close: () => void;
}

export const ONYX_TOOLTIP_CONFIG = new InjectionToken<OnyxTooltipConfig>(
  'Tooltip configuration',
);

export type OnyxTooltipColor = 'black' | 'white';

@Component({
  selector: 'onyx-tooltip-overlay',
  imports: [AsyncPipe, NgTemplateOutlet, TranslatePipe, NgComponentOutlet],
  templateUrl: './onyx-tooltip-overlay.component.html',
  styleUrls: ['./onyx-tooltip-overlay.component.scss'],
  host: { '(mouseleave)': `close()` },
})
export class OnyxTooltipOverlayComponent {
  protected readonly config = inject(ONYX_TOOLTIP_CONFIG);

  protected readonly isString = isString;

  public close(): void {
    this.config.close();
  }

  protected isTemplateRef(
    context: OnyxTooltipContext,
  ): context is TemplateRef<any> {
    return context instanceof TemplateRef;
  }
}
